<template>
  <div>
    <side-bar :drawer.sync="drawer" />
    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title @click.stop="gotoHomePage" style="cursor: pointer;">會員後台</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon title="登出" @click="logout">
        <v-icon>mdi-export</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" style="text-align: left">
            <Breadcrumbs/>
          </v-col>
          <v-col cols="12">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-footer app>
      <span>&copy; 2020</span>
    </v-footer>
  </div>
</template>

<script>
import SideBar from '@/components/layout/SideBar.vue';
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue';
import { mapGetters } from 'vuex';
import api from '@/api';

export default {
  components: {
    Breadcrumbs,
    SideBar,
  },
  data: () => ({
    drawer: null,
  }),
  computed: {
    ...mapGetters({ id_token: 'token/id_token' }),
  },
  methods: {
    gotoHomePage() {
      if (this.$route.name === 'dashboard') return;
      this.$router.push({ name: 'dashboard' });
    },
    async logout() {
      window.location.href = await api.token.signOut(this.id_token);
    },
  },
};
</script>

<style>
</style>
